/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLoginIcon24Solid = forwardRef('ArrowUiAuthLoginIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2a4 4 0 0 0-4 4v4.127H1.5a1.375 1.375 0 1 0 0 2.75H6V18a4 4 0 0 0 4 4h7a4 4 0 0 0 4-4V6a4 4 0 0 0-4-4h-7ZM6 12.877h7.3l-2.575 2.574a1.375 1.375 0 0 0 1.944 1.945l3.862-3.862a2.875 2.875 0 0 0 0-4.065l-3.862-3.862a1.375 1.375 0 0 0-1.944 1.945l2.575 2.575H6v2.75Z" })));
});
